import { useEffect, useRef } from 'react';
import { getCookie, setCookie } from './clickAndCollect';

type Props = {
    ctxValSigExpiryDays : string
}

export function useRecaptchaSession({ctxValSigExpiryDays}:Props) {

    const COOKIE_DAYS = parseInt(ctxValSigExpiryDays ?? 30);
    const COOKIE_NAME = '__ctx_val_sig';
    const recaptchaSiteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ?? "";

    const executed = useRef(false); // guard against React Strict Mode double fire

    useEffect(() => {

        if (!recaptchaSiteKey || executed.current) return;

        if (getCookie(COOKIE_NAME) === 'true') return;

        const MAX_RETRIES = 10;
        let retries = 0;
        const waitForRecaptcha = () => {
            if (window.grecaptcha?.enterprise) {
                executed.current = true;

                window.grecaptcha.enterprise.ready(async () => {
                    try {
                        await window.grecaptcha.enterprise.execute(recaptchaSiteKey, { action: 'first_visit' });
                        setCookie(COOKIE_NAME, 'true', {expires: COOKIE_DAYS,});
                    } catch (err) {
                        console.error(err);
                        executed.current = false;
                    }
                });
                return;
            }

            retries++;
            if (retries >= MAX_RETRIES) {
                console.warn('reCAPTCHA SDK failed to load after timeout');
                executed.current = false;
                return;
            }
            setTimeout(waitForRecaptcha, 300);
        };
        waitForRecaptcha();
    }, [recaptchaSiteKey, COOKIE_DAYS]);
}
